"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _EditOutlined = _interopRequireDefault(require("@material-ui/icons/EditOutlined"));

var _useOurTranslation = require("../../../utils/useOurTranslation");

var _SingleComponent = _interopRequireDefault(require("../SingleComponent"));

var _moment = _interopRequireDefault(require("moment"));

var _ProfileProvider = require("../../../provider/ProfileProvider");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getDisplayValue = function getDisplayValue(profile, componentConfiguration, t, item) {
  var value = (profile[componentConfiguration.valueName] || {}).value;
  var valueType = componentConfiguration.valueType;
  var options = componentConfiguration.options;

  if (componentConfiguration.valueName === 'workTimes') {
    valueType = 'WorkTimes';
  }

  if (valueType === 'String' && componentConfiguration.component === 'SingleChoice') {
    valueType = 'Array';
  }

  switch (valueType) {
    case 'NumberRange':
      return "".concat(value.minimum, "\u20AC - ").concat(value.maximum, "\u20AC");

    case 'LanguagesArray':
    case 'Array':
      if (item === 'paymentModel') {
        return t(options[profile.discriminator.toUpperCase()]);
      }

      var valueArray = value || [];

      if (!Array.isArray(valueArray)) {
        valueArray = [valueArray];
      }

      var fromParamType = componentConfiguration.fromParamType ? componentConfiguration.fromParamType : function (a) {
        return a;
      };
      return valueArray.map(fromParamType).filter(Boolean).map(function (value) {
        return t(options[value]);
      }).join(', ');

    case 'Boolean':
      var answer = 'false';

      if (value === true) {
        answer = 'true';
      } else if (!value) {
        answer = 'false';
      } else {
        answer = 'false';
      }

      return t(options[answer]);

    case 'String':
      {
        if (typeof componentConfiguration.valueName === 'undefined') {
          return '';
        }

        return value || '';
      }

    case 'DescriptionString':
      {
        if (typeof componentConfiguration.valueName === 'undefined') {
          return '';
        }

        return value[componentConfiguration.identifier] || '';
      }

    case 'DiagnosticArray':
      return t(componentConfiguration.translations.label);

    case 'WorkTimes':
      return value ? value.map(function (e) {
        return t(options[e]);
      }).join(', ') : '';

    case 'NumberAndUnitWithOptions':
      if (item === 'inactivationModelTime' || item === 'inactivationModelPayPerApplication' || item === 'inactivationModelFreemium') {
        var deactivation = (value.options || []).indexOf('AUTOMATIC') !== -1 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), t(componentConfiguration.additionalOptions['AUTOMATIC'])]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
        return value.number && value.unit ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: ["".concat(value.number, " ").concat(t(componentConfiguration.unitOptions[value.unit])), deactivation]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: t(componentConfiguration.translations.unlimited)
        });
      }

      return '';

    case 'FormWithInputs':
      if (item === 'billingAddress') {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [value.name, /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), value.address, /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), value.postcode, " ", value.city, " ", value.country, /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), value.email]
        });
      }

      return '';

    case 'ChoiceOrCustom':
      return "".concat(value.choice === componentConfiguration.customOption ? value.custom ? value.custom : t(componentConfiguration.options[value.choice]) : t(componentConfiguration.options[value.choice]));

    case 'Number':
      if (item === 'price' || item === 'pricePerApplication') {
        return value ? value + ' €' : '';
      }

      if (item === 'bookingStart') {
        return (0, _moment.default)(value).format('DD.MM.YYYY');
      }

      if (item === 'workExperience') {
        if (value === null) {
          return t(options[0]);
        }

        return value === 0 || value > 0 ? t(options[value]) : '';
      }

      break;

    default:
      return '';
  }
};

var EditTitledItem = function EditTitledItem(_ref) {
  var _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      item = _ref.item,
      handlePropertySave = _ref.handlePropertySave,
      notEmpty = _ref.notEmpty,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'create' : _ref$mode;
  var t = (0, _useOurTranslation.useComponentTranslation)(config);
  var profile = (0, _react.useContext)(_ProfileProvider.ProfileContext);
  var profileActions = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showEditPage = _useState2[0],
      setShowEditPage = _useState2[1];

  var handleRevert = function handleRevert() {
    profileActions.revert();
    setShowEditPage(false);
  };

  var handleOpen = function handleOpen() {
    return setShowEditPage(true);
  };

  var handlePropertySaveAndClose = function handlePropertySaveAndClose(valueName) {
    handlePropertySave(valueName);
    setShowEditPage(false);
  };

  var lineKey = (item || {}).componentConfiguration;
  var isDisabled = mode === 'display' || ((item || {}).disabled instanceof Function ? item.disabled(profile[config.valueName].value, mode) : (item || {}).disabled);
  var disabled = Boolean(isDisabled);
  var displayValue = getDisplayValue(profile, config, t, lineKey);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        className: _styleModule.default.subtitle,
        align: "left",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _styleModule.default.subtitle,
          children: t(config.translations.editLabel)
        })
      })
    }, "headline"), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _styleModule.default.editWrapper,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        variant: "body2",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: displayValue
        })
      }), !disabled && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
        "aria-label": "edit",
        className: _styleModule.default.editIcon,
        onClick: handleOpen,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditOutlined.default, {})
      })]
    }, "value"), showEditPage && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SingleComponent.default, {
      config: config,
      open: showEditPage,
      handleRevert: handleRevert,
      handlePropertySave: handlePropertySaveAndClose
    })]
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(EditTitledItem);

exports.default = _default;